<template>
  <v-container fluid>
    <v-card class="border-top-blue">
      <v-card-text>
        <push-notifications-list></push-notifications-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import PushNotificationsList from '../components/PushNotificationsList';

export default {
  name: 'push-notifications-page',
  components: {
    PushNotificationsList
  }
};
</script>
